module.exports = __webpack_public_path__ + "static/pcmag-5e9ee383c6b9493345150297b565d6a4.png";